import hash from 'object-hash';
import { isNullOrEmptyArray } from './empty';

export function calculateArrayHashCode(arr) {
  if (isNullOrEmptyArray(arr)) {
    return hash([]);
  }
  return hash(arr);
}
